import type { CommentThreadDraft } from "@/domain/comment";

/** An action on one message of a thread; `thread` is the thread that holds it. */
export type CommentMessageCommand =
  | { action: "editMessage"; thread: string; uuid: string; body: string }
  | { action: "react" | "removeReaction"; thread: string; uuid: string; emoji: string }
  | { action: "deleteMessage"; thread: string; uuid: string };

/** An action on an existing thread that answers with no thread. */
export type CommentThreadCommand =
  | CommentMessageCommand
  | { action: "resolve" | "reopen" | "mute" | "unmute"; uuid: string };

export type CommentReplyCommand = { action: "reply"; uuid: string; body: string };

export type CommentCommand =
  | CommentThreadCommand
  | CommentReplyCommand
  | { action: "create"; draft: CommentThreadDraft }
  | { action: "deleteThread"; uuid: string };

/** The thread an action changes. */
export const commandThread = (command: CommentThreadCommand | CommentReplyCommand): string =>
  "thread" in command ? command.thread : command.uuid;
